import React from 'react'
import { SettingIndicationProps } from './SettingIndication.types'
import styles from './SettingIndication.module.scss'
import cl from 'classnames'
import { Text1 } from 'components/shared/Text1'
import { capitalize } from '@material-ui/core'
import { AspectTypes } from 'models'

const SettingIndicationComponent = (props: SettingIndicationProps) => {
  const {
    label
  } = props

  return (
    <div
      className={cl(styles.container, {
        [styles.square]: label === AspectTypes.SQUARE
      })}
    >
      <Text1 style={{ color: styles.white }} overflowEllipsis>
        {capitalize(label)}
      </Text1>
    </div>
  )
}

const SettingIndication = SettingIndicationComponent
export { SettingIndication }
